import { GetterTree } from 'vuex';
import { GenericFormState } from './types';
import { RootState } from '@/vuex/types';
import IFormState from '@/modules/form/interfaces/IFormState';

export const getters: GetterTree<GenericFormState, RootState> = {
    currentStepIdx(state): number {
        return state.currentStepIdx;
    },
    currentFormStateId(state): number {
        return state.formStateId;
    },
    currentFormState(state): IFormState {
        return state.currentFormState;
    },
    currentEventId(state): number {
        return state.eventId;
    },
    currentFormFlowId(state): number {
        return state.formFlowId;
    },
};
